// Utility to get Sirius mode from localStorage at runtime
// Returns true if USE_SIRIUS is set to '1'
// Returns false if USE_SIRIUS is not set or has any other value
export function getIsSiriusEnabled(): boolean {
  const value = localStorage.getItem('USE_SIRIUS');

  return value === '1';
}
